// Central content + curated imagery for KRV Nexus corporate site.

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1548248823-ce16a73b6d49?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  heroAlt: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  architecture: "https://images.unsplash.com/photo-1460574283810-2aab119d8511?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  retail: "https://images.unsplash.com/photo-1784616275902-625176b152b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  finance: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  homeMart: "https://images.unsplash.com/photo-1760862652442-e8ff7ebdd2f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  styleMart: "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  woodMart: "https://images.unsplash.com/photo-1682184805271-11671b7ecf4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  techMart: "https://images.unsplash.com/photo-1526738549149-8e07eca6c147?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  storeConcept: "https://images.unsplash.com/photo-1782834294716-8e28c18bdba6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  furniture: "https://images.unsplash.com/photo-1758486561455-ebd0d3ba7423?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  signature: "https://images.unsplash.com/photo-1700474568247-2bf81611b293?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  research: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  team: "https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  careers: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Businesses", href: "#businesses" },
  { label: "Vision", href: "#vision" },
  { label: "Careers", href: "#careers" },
  { label: "Contact", href: "#contact" },
];

export const MARQUEE_WORDS = [
  "Vision", "Structure", "Businesses", "Value", "Scale",
  "Retail", "Research", "Education", "Innovation", "Trust",
];

export const CATEGORIES = [
  {
    id: "home-mart",
    name: "Home Mart",
    tag: "Grocery + Personal Care + Home Essentials",
    desc: "Everyday essentials for modern households — from groceries and personal care to cleaning products and home-use essentials.",
    image: IMAGES.homeMart,
    index: "01",
  },
  {
    id: "style-mart",
    name: "Style Mart",
    tag: "Fashion + Imitation Jewellery",
    desc: "Fashion and accessories curated for everyday style, occasions, and modern lifestyles.",
    image: IMAGES.styleMart,
    index: "02",
  },
  {
    id: "wood-mart",
    name: "Wood Mart",
    tag: "Furniture",
    desc: "Branded furniture, curated local-vendor collections, custom-order solutions, and the future Wood Mart Signature Collection.",
    image: IMAGES.woodMart,
    index: "03",
  },
  {
    id: "tech-mart",
    name: "Tech Mart",
    tag: "Electronics & Technology",
    desc: "Consumer electronics, appliances, gadgets, accessories, and technology for modern homes and lifestyles.",
    image: IMAGES.techMart,
    index: "04",
  },
];

export const FLOORS = [
  { level: "Ground Floor", name: "Home Mart", detail: "Grocery + Personal Care + Home Essentials" },
  { level: "First Floor", name: "Style Mart", detail: "Fashion + Imitation Jewellery" },
  { level: "Second Floor", name: "Wood Mart + Tech Mart", detail: "Furniture + Electronics" },
];

export const WOOD_STEPS = [
  { title: "Branded Furniture", desc: "Selected branded furniture displayed in-store." },
  { title: "Curated Local Vendors", desc: "Browse approved vendor catalogues and choose a preferred vendor." },
  { title: "Controlled Customization", desc: "Minor customization requests are confirmed with the vendor before finalizing." },
  { title: "Vendor Fulfilment", desc: "Approved local manufacturers and carpenters produce and deliver directly." },
  { title: "KRVMart Installation", desc: "Wood Mart provides professional installation to maintain the experience." },
];

export const WOOD_FLOW = [
  "Customer Selection", "Vendor Selection", "Customization Confirmation", "Order Confirmation",
  "Vendor Production", "Quality / Dispatch", "Customer Delivery", "Wood Mart Installation",
];

export const EDUCATION_POINTS = [
  "Market fundamentals", "Technical analysis", "Systematic trading frameworks",
  "Risk management", "Trading psychology", "Strategy development", "Practical market education",
];

export const RESEARCH_POINTS = [
  "Index analysis", "Equity market analysis", "Derivatives context", "Volatility analysis",
  "Sector analysis", "Market structure", "Educational weekly insights",
];

export const INSIGHT_CATEGORIES = [
  "Weekly Market Structure", "Index Overview", "Equity & Sector Insights",
  "Volatility Context", "Educational Concepts",
];

export const APPROACH = [
  { key: "Build", num: "01", desc: "Build businesses around genuine customer needs." },
  { key: "Connect", num: "02", desc: "Connect complementary capabilities, brands, people, and opportunities." },
  { key: "Innovate", num: "03", desc: "Use technology and better processes to improve customer experiences." },
  { key: "Scale", num: "04", desc: "Create systems that can expand across cities, categories, and markets." },
];

export const CAREER_AREAS = [
  "Retail Operations", "Category Management", "Vendor Management", "Furniture Quality & Installation",
  "Digital Marketing", "Content", "Financial Education", "Market Research", "Technology", "Customer Experience",
];

export const PARTNER_TYPES = [
  "Retail suppliers", "Furniture manufacturers", "Local carpenters", "Brands",
  "Technology partners", "Educational professionals", "Research contributors",
];

export const CONTACT_CATEGORIES = [
  "General Business Enquiries", "Vendor Partnerships", "Retail Partnerships",
  "Furniture Vendor Registration", "Education Partnerships", "Careers", "Media",
];
